import React, { useMemo } from 'react'
import Modal, {
  ModalProps,
  ActionModalButtonProps,
  ActionModalButton,
} from '../modal'
import { Icon, Text } from '../../elementals'
import _ from 'lodash'
import type { AutomationTarget } from '../../../types'

export interface GeneralModalProps extends ModalProps, AutomationTarget {
  onClose: () => void
  preventClose?: boolean
  actions?: Array<ActionModalButtonProps>
}

const GeneralModal = ({
  title,
  children,
  elmId = 'general_modal',
  size = 'tiny',
  onClose,
  actions,
  preventClose = false,
  ...rest
}: GeneralModalProps) => {
  const actionButtons = useMemo(() => {
    if (!actions) return null
    return actions.map((action, index) => {
      return (
        <ActionModalButton
          key={index}
          {...action}
          onClick={async (
            event: React.MouseEvent<HTMLButtonElement>,
            data: unknown
          ) => {
            await action?.onClick?.(event, data)
            !preventClose && onClose()
          }}
        />
      )
    })
  }, [actions, onClose])

  return (
    <Modal
      {...rest}
      title={title}
      elmId={elmId}
      closeIcon={
        <Icon
          className='close'
          data-elm-id={`${elmId}_close_button`}
          name='times'
          iconStyle='regular'
          fitted
          onClick={onClose}
        />
      }
      size={size}
    >
      <Modal.Content>
        {typeof children === 'string' ? (
          <Text.Body>{children}</Text.Body>
        ) : (
          children
        )}
      </Modal.Content>
      {actionButtons && <Modal.Actions>{actionButtons}</Modal.Actions>}
    </Modal>
  )
}

export default GeneralModal
